import React from 'react';

import CloseIcon from '@mui/icons-material/Close';

import BaseActionButton from '../BaseActionButton';
import { IBaseActionButtonProps } from '../interfaces';
import useStyles from './styles';

const CancelActionButton = (props: IBaseActionButtonProps) => {
  const { classes } = useStyles();

  return (
    <BaseActionButton {...props}>
      <CloseIcon className={classes.icon} />
    </BaseActionButton>
  );
};

export default CancelActionButton;
